__turbopack_context__.v({
  "addressLink": "style-module-scss-module__QH8Qlq__addressLink",
  "street": "style-module-scss-module__QH8Qlq__street",
});
